import React, { useState, lazy } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Filters from './Filters';
import { useHistory } from 'react-router-dom';
import { getQueryStringKeys } from 'globalutils/fmUtils';
import { periodList } from 'globalconfig/constants/keys';
import { columns } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));

const Index = ({ theme, filters, ...contentProps }) => (
  <Box style={{ ...theme.palette.contentStyle }}>
    <Breadcrumb filters={filters} />
    <Component {...contentProps} />
  </Box>
);

export default Index;

const Component = ({ paginateList, hasFetchApiStatus, Styled, i18n, changeRequest, request, pagination, setPagination }) => {
  const history = useHistory();
  const queryPeriod = getQueryStringKeys(history.location.search, 'period');

  const [values, setInitialValues] = useState({
    period: periodList.filter((ele) => ele.value == queryPeriod)[0],
  });

  const generateRows = (tableData) => {
    return tableData || [];
  };

  const information = hasFetchApiStatus?.errorMessage ? (
    <Message type="error" message={hasFetchApiStatus.errorMessage} />
  ) : (
    i18n.t('common.tableEmptyMessage')
  );

  return (
    <Styled.Wrapper>
      <div className="quickFilter"></div>
      <div className="tableWrapper">
        <Filters
          filterList={(data) => {
            changeRequest(data);
          }}
          handleReset={() => {
            changeRequest({
              period: queryPeriod,
            });
          }}
          history={history}
          values={values}
          setInitialValues={setInitialValues}
        />
        <Table
          type="server"
          defaultSortBy={{ sortBy: 'vehicle', order: 'desc' }}
          title=""
          changeRequest={changeRequest}
          baseRequest={request}
          totalRecords={paginateList?.totalElements || 0}
          columns={columns}
          data={generateRows(paginateList?.content)}
          emptyMessage={information}
          itemsPerPage={15}
          pageinationReset={pagination}
          actions={[]}
          i18n={i18n}
          pagenationClicked={(e) => setPagination(!e)}
        />
      </div>
    </Styled.Wrapper>
  );
};

Component.propTypes = {
  paginateList: PropTypes.object.isRequired,
  hasFetchApiStatus: PropTypes.object.isRequired,
  Styled: PropTypes.object.isRequired,
  i18n: PropTypes.array.isRequired,
};
